import React, { useState } from 'react'
import { Input } from '~/components/common/CurieInput'
import { Button } from '~/components/common/Button'

import { BetterToast } from '~/utils/toast'
import 'swiper/css'
import { signin } from '~/services/userService'

interface SignInMfaVerifyProps {
  email: string
  password: string
  mfaCode: string
  handleMfaCodeChange: (code: string) => void
  handleCancelMfaVerify: () => void
}

export function SignInMfaVerify({
  email,
  password,
  mfaCode,
  handleMfaCodeChange,
  handleCancelMfaVerify
}: SignInMfaVerifyProps) {
  const [isDisabled, setIsDisabled] = useState(false)

  const handleVerificationSubmit = async () => {
    if (!/^\d{6}$/.test(mfaCode)) {
      return BetterToast.error('Please enter a valid 6-digit verification code')
    }

    try {
      setIsDisabled(true)
      const response = await signin(email, password, mfaCode)
      if ('mfa_required' in response) {
        // won't be hit in this case
        setIsDisabled(false)
        return
      }
      const { referer } = response
      const queryParams = location.search
      const url = new URL(location.href)
      const path = referer || '/'
      location.href = url.origin + path + queryParams
    } catch (err) {
      const error = err as unknown as Error
      BetterToast.error(error.message)
      setIsDisabled(false)
    }
    setIsDisabled(false)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value
    if (/^\d{0,6}$/.test(code)) handleMfaCodeChange(code)
  }

  return (
    <div className='flex-1 flex flex-col justify-center items-center w-full h-full pb-4'>
      <div className='w-full max-w-[500px] text-center space-y-4 p-5 pt-[60px]'>
        <h1 className='mb-2 text-center font-bold text-4xl select-none'>Verify Your Sign In</h1>
        <h2 className='text-lg font-medium select-none'>Enter your MFA 6-digit code to continue</h2>
        <Input
          type='text'
          id='verificationCode'
          placeholder='Enter 6-digit verification code'
          value={mfaCode ?? ''}
          onChange={handleInputChange}
          className='label-md-normal'
          autoComplete='off'
        />
        <div className='flex justify-between w-full mx-auto'>
          <Button
            variant='outlined'
            onClick={handleCancelMfaVerify}
            isDisabled={isDisabled}
            className='body-lg-bold'
          >
            Cancel
          </Button>
          <Button
            variant='primary'
            onClick={handleVerificationSubmit}
            className='body-lg-bold'
            isDisabled={isDisabled}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SignInMfaVerify
